export { default } from './ClientOrderListSkeleton';
